import { queryOptions, useQuery } from '@tanstack/react-query';

import { twoFactorApi } from '../api/auth-api';

import { authKeys } from './auth-keys';

export function twoFactorStatusQueryOptions() {
  return queryOptions({ queryKey: authKeys.twoFactor(), queryFn: twoFactorApi.status });
}

export function useTwoFactorStatus() {
  return useQuery(twoFactorStatusQueryOptions());
}
